import { render, staticRenderFns } from "./Rechazos.vue?vue&type=template&id=0cec6e19&"
import script from "./Rechazos.vue?vue&type=script&lang=js&"
export * from "./Rechazos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports